import styled from 'styled-components';
import { colors } from '@/constants';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    margin-top: 6px;
`;

export const Badge = styled.div<{ $isActive?: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 160px;
    padding: 4px 8px;
    border-radius: 999px;
    background-color: ${({ $isActive }) => ($isActive ? colors.alert.green100 : colors.alert.orange100)};
    border: 1px solid ${({ $isActive }) => ($isActive ? colors.alert.green110 : colors.alert.orange300)};
`;

export const LabelGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
`;

export const TagLabel = styled.span<{ $isActive?: boolean }>`
    font-size: 9px;
    font-weight: 700;
    color: ${({ $isActive }) => ($isActive ? colors.alert.green300 : colors.alert.orange300)};
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 0.02em;
`;

export const ComboName = styled.span`
    font-size: 10px;
    font-weight: 600;
    color: ${colors.brand.grafite};
    line-height: 1.1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 130px;
`;

export const Strip = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding: 0 18px 12px;
`;

export const StripBar = styled.div<{ $isActive?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid ${({ $isActive }) => ($isActive ? colors.alert.green110 : colors.alert.orange300)};
    background-color: ${({ $isActive }) => ($isActive ? colors.alert.green50 : colors.alert.orange100)};
`;

export const StripIconBox = styled.div<{ $isActive?: boolean }>`
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: ${({ $isActive }) => ($isActive ? colors.alert.green100 : colors.alert.orange200)};
`;

export const StripText = styled.p`
    flex: 1;
    margin: 0;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.35;
    color: ${colors.brand.grafite};
    min-width: 0;
`;

export const StripHighlight = styled.span<{ $isActive?: boolean }>`
    color: ${({ $isActive }) => ($isActive ? colors.alert.green300 : colors.alert.orange300)};
`;

export const StripCheck = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StripPendingLabel = styled.span`
    font-size: 10px;
    font-weight: 700;
    color: ${colors.alert.orange300};
    white-space: nowrap;
`;

export const StripStatusLabel = styled.span<{ $isActive?: boolean }>`
    font-size: 10px;
    font-weight: 700;
    color: ${({ $isActive }) => ($isActive ? colors.alert.green300 : colors.alert.orange300)};
    white-space: nowrap;
`;

export const StripStatusGroup = styled.div`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
`;
